import { render, staticRenderFns } from "./SynchronizeView.vue?vue&type=template&id=8d335272&scoped=true&"
import script from "./SynchronizeView.vue?vue&type=script&lang=js&"
export * from "./SynchronizeView.vue?vue&type=script&lang=js&"
import style0 from "./SynchronizeView.vue?vue&type=style&index=0&id=8d335272&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d335272",
  null
  
)

export default component.exports